// @ts-nocheck

import { memo, forwardRef, FC, useMemo, ChangeEvent } from 'react'
import { Input } from '@chakra-ui/react'

import { brazilianDateMask } from 'utils/masks'
import NumberFilterField from './components/NumberFilterField'
import InputFilterField from './components/InputFilterField'
import TextareaFilterField from './components/TextareaFilterField'
import BooleanFilterField from './components/BooleanFilterField'
import DateInputFilterField from './components/DateInputFilterField'
import DatetimeInputFilterField from './components/DatetimeInputFilterField'

type PossibleFields = {
  [key: string]: JSX.Element
}

export type DynamicFieldProps = {
  id?: string
  name?: string
  value?: string
  onChange?: (event: any) => void
}

type Props = DynamicFieldProps & {
  type: string | 'TEXT' | 'STRING' | 'DATE' | 'DATETIME' | 'NUMBER' | 'BOOLEAN'
}

const DynamicInputByType: FC<Props> = forwardRef<any, Props>(({ value, id, onChange, type, name, ...rest }, ref) => {
  function setDateMask(event: ChangeEvent<HTMLInputElement>) {
    event.target.value = brazilianDateMask(event.target.value)
    if (onChange) onChange(event)
  }

  const Component = useMemo(() => {
    const possibleFields: PossibleFields = {
      STRING: <InputFilterField id={id} ref={ref} defaultValue={value} name={name} onChange={onChange} {...rest} />,
      TEXT: <TextareaFilterField id={id} ref={ref} defaultValue={value} name={name} onChange={onChange} {...rest} />,
      NUMBER: <NumberFilterField id={id} ref={ref} defaultValue={value} name={name} onChange={onChange} {...rest} />,
      BOOLEAN: <BooleanFilterField id={id} ref={ref} defaultValue={value} name={name} onChange={onChange} {...rest} />,
      DATE: <DateInputFilterField id={id} ref={ref} defaultValue={value} name={name} onChange={setDateMask} {...rest} />,
      DATETIME: <DatetimeInputFilterField id={id} ref={ref} defaultValue={value} name={name} onChange={onChange} {...rest} />,
    }

    if (!type) return <Input id={id} ref={ref} defaultValue={value} name={name} onChange={onChange} {...rest} />

    return possibleFields[type]
  }, [setDateMask, type])

  return Component
})

export default memo(DynamicInputByType)
